import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import HeaderBackgroundBanner from 'components/HeaderBackgroundBanner';
import { contactPersonelFormUrl } from 'constants/forms';

const Cookie = ({ t }) => {
  const styles = {
    list: {
      listStyleType: 'disc',
    },
    listItem: {
      fontSize: 'inherit',
      marginBottom: '0.2rem',
    },
  };

  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('agreements'),
      url: '/',
    },
    {
      label: t('cookiePolicy'),
      url: '/agreements/cookie',
    },
  ];

  return (
    <main className="has-header">
      <HeaderBackgroundBanner />

      <div className="container">
        <div className="mt-4 mb-4 mt-lg-3 mb-lg-3">
          <Breadcrumb links={breadcrumbs} />
        </div>

        <div className="mx-auto mt-4 mb-5" style={{ maxWidth: '800px' }}>
          <h1 className="mb-3">{t('cookiePolicy')}</h1>
          <p>
            iyiMakina Bilgi Teknolojileri ve Ticaret A.Ş.(Bundan sonra ‘‘iyiMakina’’) olarak, https://www.iyimakina.com (‘’Site’’) ve uygulamalarımızı ziyaretlerinizde deneyiminizi geliştirmek adına çerezler, gifler gibi teknolojilerden (‘‘çerezler’’) yararlanmaktayız. 6689 sayılı Kişisel Verilerin Korunması Kanunu (‘‘Kanun’’) öncelikle olmak üzere iyiMakina’nın tabi olduğu mevzuata uygun olacak şekilde bu teknolojilerinin kullanımı gerçekleştirilmektedir.
          </p>
          <p> İşbu Aydınlatma Metninin amacı, Site ve uygulamalarımızın kullanımı sırasında kullanılmakta olan çerezler ve işlenmekte olan kişisel veriler hakkında sizleri bilgilendirmektir. Hangi tür çerezlerin nasıl amaçlarla kullandığımız ve sizlerin çerezleri nasıl kontrol edebileceğinizden bahsedeceğiz.</p>
          <p>iyiMakina olarak Site’de kullanılmakta olan çerezlerin kullanılmasından vazgeçilebilir, çeşitlerini ve işlevlerini değiştirebilir veya Site’ye yeni çerezler ekleyebiliriz. Dolayısıyla işbu aydınlatma metninin hükümlerini uygun görüldüğü takdirde değiştirme hakkını saklı tutarız. İşbu metinde gerçekleştirilmiş her türlü değişiklik herhangi bir kamuya açık mecrada yayımlanmakla birlikte yürürlüğe girecektir.</p>
          <p>
            Kişisel verilerinizin işlenmesine dair
            {' '}
            <a href="/agreements/kvkk-policy">KVKK Politikası</a>
            {' '}
            metnine ulaşabilirsiniz.
          </p>

          <h6 className="mt-4">Hangi Çerezler Hangi Amaçlarla Kullanılmaktadır?</h6>
          <p>Site’de birden çok amaçla çerezler kullanılmakta ve bunlar vasıtasıyla kişisel verilerinizi işlemekteyiz. Amaçların başlıcaları aşağıdaki gibidir:</p>
          <ol style={styles.list}>
            <li style={styles.listItem}>Site’nin işlevselliğinin sürdürülebilirliğinin devamı için temel fonksiyonları gerçekleştirmek.</li>
            <li style={styles.listItem}>Site’yi analiz etmek ve Site’nin performansını artırmak.</li>
            <li style={styles.listItem}>Site’ye erişim sağlayanların sayısının tespit edilmesi ve buna göre Site’nin performansını geliştirmek için gerekli tashihlerin yapılması veya ziyaretçilerin site deneyimlerinin geliştirilmesi.</li>
            <li style={styles.listItem}>Site’ye erişen ziyaretçinin daha sonraki ziyaretinde kullanıcı adı bilgisi ya da arama sorgularının hatırlanması.</li>
            <li style={styles.listItem}>Kişiselleştirme, hedefleme ve reklamcılık faaliyeti gerçekleştirmek.</li>
          </ol>

          <h6 className="mt-4">Sitemizde ve Uygulamamızda Kullanılan Çerezler</h6>
          <h6>Zorunlu Çerezler</h6>
          <p>Site’nin faaliyetlerine devam edebilmesi, özelliklerinden ve hizmetlerinden yararlanılabilmesi için kullanımı mecburi olan çerezlerdir. Örneğin, Sitemizde oturum açtığınızda devreye giren kimlik doğrulama çerezleri, Sitemizde bir sayfadan diğerine geçişinizde etkin olan oturumunuzun devam etmesini sağlamaktadır.</p>
          <h6>İşlevsellik ve Tercih Çerezleri</h6>
          <p>Site’de yaptığınız tercihleri ve/veya Site’de geçirdiğiniz süre boyunca yaptığınız seçimleri hatırlayan ve buna istinaden sunulan hizmetlerin kişiselleşmesini sağlayan çerezlerdir. Örneğin site üzerindeki dil seçiminiz bir sonraki girişinizde de aynı kalır. </p>
          <h6>Sosyal Medya Çerezleri</h6>
          <p>Sosyal medya kullanımlarınız hakkında veri toplayan çerezlerdir. Örnek olarak kişiselleştirilmiş reklamlar oluşturulması verilebilir.</p>
          <h6>Performans ve Analiz Çerezleri</h6>
          <p>Sitenin kullanımını ve performansını analiz ederek hizmetlerimizi geliştirmemizi sağlayan çerezlerdir. Örnek olarak ziyaretçilerin en çok hangi sayfalarda zaman geçirdiği verilebilir. </p>
          <h6>Hedefleme veya Reklam çerezleri</h6>
          <p>Sizlere sitemizde veya sitemiz haricindeki mecralarda ürün ve hizmet tanıtımını yapmak için kullanılan çerezlerdir. Bazı iş ortaklarımızla sizlere sitemiz dahilinde veya dışında reklam ve tanıtım yapmak için iş birliğine gidebilir. Örneğin, sitemizde gördüğünüz bir reklama tıklayıp tıklamadığınızı, eğer reklam ilginizi çektikten sonra o reklam yönlendirdiği sitedeki hizmetten faydalanıp faydalanmadığınızı takip etmek için çerezler kullanılabilmektedir.</p>

          <h6 className="mt-4">Çerezlerin Kullanımını Nasıl Kontrol Edebilirim?</h6>
          <p>Tarayıcınızın ayarlarını değiştirerek çerezlere ilişkin tercihlerinizi kişiselleştirme imkanına sahipsiniz.</p>
          <table className="table table-responsive">
            <tr>
              <th>Website</th>
              <th>URL</th>
            </tr>
            <tr>
              <td>Adobe</td>
              <td>
                <a href="http://www.adobe.com/uk/privacy/opt-out.html" target="_blank" rel="noreferrer">
                  http://www.adobe.com/uk/privacy/opt-out.html
                </a>
              </td>
            </tr>
            <tr>
              <td>AOL</td>
              <td>
                <a href="https://help.aol.com/articles/restore-security-settings-and-enable-cookie-settings-on-browser" target="_blank" rel="noreferrer">
                  https://help.aol.com/articles/restore-security-settings-and-enable-cookie-settings-on-browser
                </a>
              </td>
            </tr>
            <tr>
              <td>Google Adwords</td>
              <td>
                <a href="https://support.google.com/ads/answer/2662922?hl=en" target="_blank" rel="noreferrer">
                  https://support.google.com/ads/answer/2662922?hl=en
                </a>
              </td>
            </tr>
            <tr>
              <td>Google Analytics</td>
              <td>
                <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noreferrer">
                  https://tools.google.com/dlpage/gaoptout
                </a>
              </td>
            </tr>
            <tr>
              <td>Google Chrome</td>
              <td>
                <a href="http://www.google.com/support/chrome/bin/answer.py?hl=en&answer=95647" target="_blank" rel="noreferrer">
                  http://www.google.com/support/chrome/bin/answer.py?hl=en&answer=95647
                </a>
              </td>
            </tr>
            <tr>
              <td>Internet Explorer</td>
              <td>
                <a href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank" rel="noreferrer">
                  https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies
                </a>
              </td>
            </tr>
            <tr>
              <td>Mozilla Firefox</td>
              <td>
                <a href="http://support.mozilla.com/en-US/kb/Cookies" target="_blank" rel="noreferrer">
                  http://support.mozilla.com/en-US/kb/Cookies
                </a>
              </td>
            </tr>
            <tr>
              <td>Opera</td>
              <td>
                <a href="http://www.opera.com/browser/tutorials/security/privacy/" target="_blank" rel="noreferrer">
                  http://www.opera.com/browser/tutorials/security/privacy/
                </a>
              </td>
            </tr>
            <tr>
              <td>Safari</td>
              <td>
                <a href="https://support.apple.com/kb/ph19214?locale=tr_TR" target="_blank" rel="noreferrer">
                  https://support.apple.com/kb/ph19214?locale=tr_TR
                </a>
              </td>
            </tr>
          </table>

          <h6 className="mt-4">Veri Sahibi Olarak Haklarınız Nelerdir?</h6>
          <p>Kanun’un 11. maddesi uyarınca veri sahipleri,</p>
          <ol style={styles.list}>
            <li style={styles.listItem}>Kişisel veri işlenip işlenmediğini öğrenme,</li>
            <li style={styles.listItem}>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
            <li style={styles.listItem}>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
            <li style={styles.listItem}>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,</li>
            <li style={styles.listItem}>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
            <li style={styles.listItem}>Kanun ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
            <li style={styles.listItem}>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,</li>
            <li style={styles.listItem}>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme haklarına sahiptir.</li>
          </ol>
          <p className="mt-3">
            Yukarıda sıralanan haklarınıza yönelik başvurularınızı
            {' '}
            <a href={contactPersonelFormUrl} target="_blank" rel="noreferrer">İlgili Kişi Formu'nu</a>
            {' '}
            doldurarak Şirketimize iletebilirsiniz. Talebinizin içeriğine göre en kısa sürede ve en geç otuz gün içinde talepleriniz ücretsiz olarak sonuçlandırılacaktır. İşlemin ayrıca bir maliyet gerektirmesi halinde Kişisel Verileri Koruma Kurulu tarafından belirlenecek tarifeye göre tarafınızdan ücret talep edilebilecektir.
          </p>
        </div>
      </div>
    </main>
  );
};

Cookie.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async ({ req }) => {
  const { t } = req;

  return {
    props: {
      headTitle: t('cookiePolicy'),
    },
  };
};

Cookie.Layout = Layout;

export default withTranslation('common')(Cookie);
